import React from 'react';
import { useI18n } from '../../../contexts/I18nContext';
import './Steps.scss';

export default function Steps() {
  const { t } = useI18n();
  const items = t('videoGeneration.wan.steps.items');
  return (
    <section className="wan-steps">
      <div className="wan-steps__inner">
        <h2>{t('videoGeneration.wan.steps.title')}</h2>
        <p className="wan-steps__sub">{t('videoGeneration.wan.steps.sub')}</p>

        <div className="wan-steps__grid">
          {items.map((it, idx) => (
            <React.Fragment key={it.num}>
              <div className="wan-step">
                <div className="wan-step__badge">{it.num}</div>
                <h3>{it.title}</h3>
                <p>{it.text}</p>
              </div>
              {idx < items.length - 1 && <div className="wan-steps__arrow" />}
            </React.Fragment>
          ))}
        </div>
      </div>
    </section>
  );
}